import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Box, Tab, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../store';
import { setSelectedMenuAction } from '../store/slice';
import AdminSettings from './AdminSettings';
import HistoryTable from './HistoryTable';
import { MenuInterface } from './types';


export default function AdminContainer() {
    const dispatch = useDispatch();
    const profile = useSelector((state: RootState) => state.profile);

    const [tabValue, setTabValue] = useState<string>("1");
    useEffect(() => {
        dispatch(setSelectedMenuAction(MenuInterface.ADMIN));
    }, []);

   
    const handleTabChange = (event: React.SyntheticEvent, newValue: string) => {
        setTabValue(newValue);
    };

    return (
        <Box sx={{width: '100%', flex: 1, display: 'flex', flexDirection: 'row', maxHeight: 'calc(100vh - 90px)', minHeight: 'calc(100vh - 90px)', overflow: 'hidden'}}>
            {profile.isAdmin && 
            <>
                <Box sx={{flex: 1, flexDirection: 'column', display: {md: 'none', xs: 'flex'}}}>
                    <TabContext value={tabValue}>
                        <Box sx={{
                            bgcolor: 'background.paper',
                            width: {sm: 500, xs: "80%"},
                            marginX: 'auto',
                            pt: 2,
                            pb: 2,
                            borderBottomRightRadius: 10,
                            borderBottomLeftRadius: 10,
                            display: 'flex',
                            justifyContent: 'center',
                        }}>
                            <TabList 
                                onChange={handleTabChange} 
                                aria-label="lab API tabs example"
                                sx={{
                                    '& .MuiTab-root': {
                                        bgcolor: 'background.default',
                                        margin: '0 4px',
                                        borderRadius: '4px 4px 0 0',
                                        '&.Mui-selected': {
                                            bgcolor: 'primary.main',
                                            color: 'primary.contrastText'
                                        }
                                    }
                                }}
                            >
                                <Tab label="Settings" value="1" sx={{px: {sm: 6, xs: 4}, fontSize: {sm: 16, xs: 14}}}/>
                                <Tab label="History" value="2" sx={{px: {sm: 6, xs: 4}, fontSize: {sm: 16, xs: 14}}}/>
                            </TabList>
                        </Box>
                        <TabPanel value="1" sx={{overflowY: 'auto'}}>
                            <AdminSettings />
                        </TabPanel>
                        <TabPanel value="2" sx={{overflowY: 'auto'}}>
                            <HistoryTable />
                        </TabPanel>
                    </TabContext>
                </Box>
                <Box sx={{flex: 1, display: {md: 'flex', xs: 'none'}, flexDirection: 'row'}}>
                    <AdminSettings/>
                    <Box sx={{flex: 1, display: 'flex', flexDirection: 'column', px: {md: 2, xs: 0}, pt: 3}}>
                        <Typography variant="h6" color="text.secondary" sx={{mb: 2}}>History</Typography>
                        <HistoryTable />
                    </Box>
                </Box>
            </>
            }
            {!profile.isAdmin && 
            <Box display="flex" justifyContent="center" alignItems="center" sx={{width: '100%', height: '100%', mt: 6}}>
                <Typography variant="h6" color="warning">You are not authorized to access this page</Typography>
            </Box>
            }
        </Box>
    );
}